export default {
  // Brand & meta
  "brand.name": "USFansLink",
  "brand.tagline": "Niezależne centrum zasobów USFans Spreadsheet",
  "meta.home.title": "USFans Spreadsheet: poradniki, opinie, wysyłka i nowości",
  "meta.home.description": "Poznaj USFans Spreadsheet — poradniki produktowe, wskazówki QC, informacje o wysyłce, zasoby magazynu, opinie i najnowsze aktualizacje USFans.",
  "meta.article.title": "Poradnik USFans Spreadsheet: co to jest i jak z niego korzystać",
  "meta.article.description": "Kompletny, niezależny poradnik po USFans Spreadsheet — jak działa, jak szukać produktów, wskazówki dotyczące kategorii, kontroli QC, wysyłki i bezpieczeństwa.",

  // Navigation
  "nav.home": "Strona główna",
  "nav.guide": "Poradnik USFans Spreadsheet",
  "nav.buyingGuide": "Przewodnik zakupowy",
  "nav.categories": "Kategorie",
  "nav.faq": "FAQ",
  "nav.explore": "Otwórz arkusz",

  // Hero
  "hero.badge": "Niezależne centrum zasobów",
  "hero.title": "USFans Spreadsheet — znajdź produkty, poradniki i zasoby szybciej",
  "hero.subtitle": "Twoje niezależne źródło wiedzy o USFans Spreadsheet: badania produktów, poradniki QC, informacje o wysyłce, wskazówki magazynowe i opinie o USFans.",
  "hero.supporting": "Szukasz arkusza USFans Spreadsheet? Zacznij tutaj. Przeglądaj uporządkowane zasoby produktowe, naucz się badać produkty, zrozum informacje QC, porównaj opcje i podejmuj lepsze decyzje przed zakupem.",
  "hero.cta.primary": "USFans Spreadsheet",
  "hero.cta.secondary": "Kup teraz",
  "hero.cta.guide": "Przeczytaj poradnik USFans",
  "hero.trust": "Aktualne zasoby · Niezależne poradniki · Informacje o bezpieczeństwie",

  // Category dropdown
  "categories.dropdown.label": "Przeglądaj kategorie",
  "categories.dropdown.hint": "Wybierz kategorię, aby otworzyć ją na stronie głównej",

  // Category names
  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  // Categories section
  "categories.title": "Popularne kategorie produktów",
  "categories.subtitle": "Przejdź bezpośrednio do kategorii na stronie głównej. Każdy przycisk otwiera pasującą stronę produktu.",

  // About section
  "about.title": "Czym jest USFans Spreadsheet?",
  "about.body": "USFans Spreadsheet to zasób do odkrywania i badania produktów. Pomaga użytkownikom porządkować informacje o produktach, przeglądać kategorie i badać produkty przed podjęciem decyzji o zakupie. Zamiast przeskakiwać między rozproszonymi stronami, możesz przeglądać przedmioty, porównywać opcje i sprawdzać szczegóły w jednym miejscu.",
  "about.body2": "Naszym zadaniem w USFansLink jest ułatwienie tego procesu. Publikujemy niezależne, przyjazne dla początkujących poradniki, które wyjaśniają, jak działa arkusz, jak czytać informacje o produktach i co zweryfikować przed wydaniem pieniędzy.",

  // Why section
  "why.title": "Dlaczego warto korzystać z naszych zasobów USFans?",
  "why.subtitle": "Wszystko tutaj jest napisane po to, aby pomóc Ci badać z większą pewnością — bez kierowania Cię do jednego sprzedawcy.",
  "why.items": [
    "Uporządkowane informacje",
    "Poradniki dla początkujących",
    "Instrukcje badania produktów",
    "Wyjaśnienia QC",
    "Informacje o wysyłce",
    "Poradniki magazynowe",
    "Zasoby opinii",
    "Świadomość kuponów",
    "Informacje o bezpieczeństwie",
    "Regularne aktualizacje"
  ],

  // Guide section
  "guide.title": "Jak korzystać z USFans Spreadsheet",
  "guide.body": "Kilka prostych nawyków znacznie przyspiesza badanie produktów. Oto prosty przepływ pracy, który możesz zastosować, niezależnie od tego, czy kupujesz po raz pierwszy, czy badasz regularnie.",
  "guide.steps": [
    "Wybierz kategorię pasującą do tego, czego szukasz.",
    "Użyj wyszukiwania i filtrów, aby zawęzić listę produktów.",
    "Przejrzyj informacje o produkcie wyświetlane dla każdego przedmiotu.",
    "Sprawdź zdjęcia QC lub szczegóły, jeśli są dostępne.",
    "Porównaj opcje i zweryfikuj aktualne informacje przed zakupem."
  ],

  // Article entry
  "articleEntry.title": "Zacznij od naszego kompletnego poradnika",
  "articleEntry.body": "Nowy w USFans Spreadsheet? Przeczytaj nasz pełny, oryginalny poradnik o tym, jak działa arkusz, wskazówki dotyczące kategorii, kontroli QC, wysyłki i bezpieczeństwa — napisany dla osób szukających jasnych, uczciwych informacji.",
  "articleEntry.button": "Przeczytaj kompletny poradnik",
  "articleEntry.meta": "Regularnie aktualizowane · Niezależne · Bez powiązań",

  // FAQ
  "faq.title": "Najczęściej zadawane pytania",
  "faq.subtitle": "Szybkie odpowiedzi na pytania najczęściej zadawane na temat USFans Spreadsheet.",
  "faq.items": [
    {
      "q": "Czym jest USFans Spreadsheet?",
      "a": "To zasób do odkrywania i badania produktów, który porządkuje informacje o produktach, kategorie i linki, aby kupujący mogli badać przedmioty przed zakupem."
    },
    {
      "q": "Jak korzystać z USFans Spreadsheet?",
      "a": "Zacznij od wyboru kategorii, następnie użyj wyszukiwania i filtrów, aby zawęzić wyniki, przejrzyj szczegóły produktu i informacje QC oraz porównaj opcje przed zakupem."
    },
    {
      "q": "Czy korzystanie z USFans jest bezpieczne?",
      "a": "Sam arkusz jest narzędziem badawczym. Zawsze weryfikuj niezależnie informacje o produkcie, sprzedawcy i płatnościach oraz uważaj na fałszywe strony i podejrzane linki."
    },
    {
      "q": "Ile kosztuje wysyłka USFans?",
      "a": "Koszty wysyłki zależą od wagi, wymiarów, miejsca docelowego i metody. Rzeczywiste ceny mogą się zmieniać, więc zawsze sprawdzaj aktualne informacje przed zamówieniem."
    },
    {
      "q": "Czy USFans ma kody rabatowe?",
      "a": "Promocje często się zmieniają. Nigdy nie wymyślamy kodów rabatowych, więc zawsze weryfikuj aktualną ofertę na oficjalnej stronie przed jej użyciem."
    }
  ],

  // Final CTA
  "cta.title": "Gotowy na odkrycie USFans Spreadsheet?",
  "cta.body": "Poznaj nasze poradniki, porównania, opinie i zasoby, aby ułatwić sobie badanie USFans.",
  "cta.button": "Otwórz USFans Spreadsheet",

  // Articles section
  "articles.title": "Najnowsze poradniki USFans",
  "articles.subtitle": "Niezależne, oryginalne poradniki o USFans Spreadsheet, opiniach, wysyłce, magazynie, QC, sprzedawcach i bezpieczeństwie.",
  "articles.read": "Czytaj",

  // Footer
  "footer.about": "USFansLink to niezależne centrum zasobów dla USFans Spreadsheet. Publikujemy poradniki, opinie i informacje o bezpieczeństwie, aby pomóc kupującym badać z pewnością.",
  "footer.resources": "Zasoby",
  "footer.categories": "Kategorie",
  "footer.languages": "Języki",
  "footer.disclaimer": "Ta strona udostępnia niezależne materiały informacyjne. Nie gwarantujemy autentyczności, bezpieczeństwa, legalności, jakości, dostępności ani działania jakiegokolwiek produktu, sprzedawcy, strony internetowej lub usługi osób trzecich. Zawsze niezależnie weryfikuj aktualne informacje przed dokonaniem zakupu.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",

  // Article page
  "article.backHome": "Wróć na stronę główną",
  "article.tocTitle": "Spis treści",
  "article.updated": "Ostatnia aktualizacja",
  "article.published": "Opublikowano",
  "article.readTime": "min czytania",
  "article.h1": "Poradnik USFans Spreadsheet: co to jest i jak z niego korzystać",
  "article.intro": "USFans Spreadsheet to zasób do odkrywania i badania produktów, z którego korzysta wielu kupujących, aby przeglądać uporządkowane informacje o produktach, odkrywać kategorie i badać przedmioty przed zakupem. Ten niezależny poradnik wyjaśnia, czym jest arkusz, jak działa, jak z niego korzystać i co sprawdzić przed zakupem.",
  "article.intro2": "Nie jesteśmy powiązani z żadnym sprzedawcą ani sklepem. Nasz cel jest prosty: pomóc Ci podejmować lepsze decyzje dzięki jasnym, uczciwym informacjom.",
  "article.toc": [
    "Czym jest USFans Spreadsheet?",
    "Jak działa USFans Spreadsheet",
    "Wyjaśnienie kategorii produktów",
    "Jak korzystać z USFans Spreadsheet",
    "Wskazówki dotyczące badań produktów i QC",
    "Podstawy wysyłki i magazynu",
    "Wskazówki bezpieczeństwa przed zakupem",
    "Najczęściej zadawane pytania"
  ],
  "article.s1Title": "Czym jest USFans Spreadsheet?",
  "article.s1Text": "USFans Spreadsheet to ustrukturyzowane źródło, które gromadzi informacje o produktach w jednym miejscu. Zamiast odwiedzać wiele osobnych stron, kupujący mogą przeglądać produkty, kategorie i linki z jednego uporządkowanego widoku. Jest powszechnie używany przez osoby badające buty, odzież i akcesoria.",
  "article.s1Text2": "Ważne jest, aby zrozumieć, że arkusz jest narzędziem badawczo-odkrywczym, a nie sklepem. Wskazuje on produkty i sprzedawców, ale ostateczny zakup i każda transakcja odbywają się na stronach, do których prowadzą linki.",
  "article.s2Title": "Jak działa USFans Spreadsheet",
  "article.s2Text": "Arkusz zwykle porządkuje produkty w wierszach, przy czym każdy wiersz pokazuje szczegóły, takie jak nazwa produktu, kategoria, informacje o cenie i link do oferty. Filtry i wyszukiwanie pomagają zawęzić długą listę do przedmiotów, które mają dla Ciebie znaczenie.",
  "article.s2Text2": "Niektóre wersje zawierają również notatki lub zdjęcia z kontroli jakości (QC), które dają bliższy wgląd w produkt przed podjęciem decyzji. Traktuj je jako pomocne odniesienia, a nie gwarancje — jakość może się różnić między przedmiotami.",
  "article.s3Title": "Wyjaśnienie kategorii produktów",
  "article.s3Text": "Produkty są zwykle grupowane w przejrzyste kategorie, dzięki czemu szybciej znajdziesz to, czego potrzebujesz. Poniższa tabela wymienia główne kategorie i to, na co zwracać uwagę w każdej z nich.",
  "article.s3Table.area": "Kategoria",
  "article.s3Table.what": "Na co zwrócić uwagę",
  "article.s3Table.notes": "Uwagi",
  "article.s3Rows": [
    { "area": "Buty", "what": "Model, rozmiar, kolor i stan", "notes": "Sprawdź rozmiar i zdjęcia QC" },
    { "area": "Bluzy / Swetry", "what": "Krój, materiał i kolor", "notes": "Sprawdź tabele rozmiarów, jeśli są dostępne" },
    { "area": "Koszulki", "what": "Rozmiar, nadruk i materiał", "notes": "Zweryfikuj wymiary" },
    { "area": "Kurtki", "what": "Styl, rozmiar i sezon", "notes": "Potwierdź szczegóły przed zamówieniem" },
    { "area": "Torby i akcesoria", "what": "Typ, wymiary i kolor", "notes": "Sprawdź opisy przedmiotów" }
  ],
  "article.s4Title": "Jak korzystać z USFans Spreadsheet",
  "article.s4Text": "Nie potrzebujesz żadnych specjalnych narzędzi, aby skutecznie korzystać z arkusza. Wystarczy prosty, uważny przepływ pracy.",
  "article.s4Steps": [
    "Wybierz kategorię pasującą do tego, czego szukasz.",
    "Użyj wyszukiwania i filtrów, aby zawęzić listę produktów.",
    "Otwórz produkt i przeczytaj jego pełne informacje.",
    "Sprawdź zdjęcia QC lub notatki, gdy są dostępne.",
    "Porównaj dwie lub trzy opcje przed podjęciem decyzji.",
    "Zweryfikuj aktualną cenę, dostępność i informacje o sprzedawcy."
  ],
  "article.s5Title": "Wskazówki dotyczące badań produktów i QC",
  "article.s5Text": "Dobre badanie produktu sprowadza się do sprawdzania szczegółów, a nie zaufania pojedynczemu zdjęciu. Oglądaj wiele zdjęć, uważnie czytaj opis i porównuj ten sam produkt w różnych źródłach, jeśli to możliwe.",
  "article.s5Text2": "Zdjęcia QC pokazują bliższy widok rzeczywistego przedmiotu, w tym szwy, etykiety i wszelkie widoczne ślady. Użyj ich, aby wcześnie wychwycić oczywiste problemy, ale pamiętaj, że zdjęcie nie zastąpi przeczytania pełnej oferty.",
  "article.s6Title": "Podstawy wysyłki i magazynu",
  "article.s6Text": "Koszt wysyłki zależy od kilku czynników, w tym wagi, wymiarów, miejsca docelowego i wybranej metody wysyłki. Etap magazynowy to moment, w którym produkty mogą być przechowywane, sprawdzane i przygotowywane przed wysłaniem do Ciebie.",
  "article.s6Text2": "Rzeczywiste ceny i terminy wysyłki mogą się zmieniać. Zawsze sprawdzaj aktualne stawki i szacunki dostawy przed zamówieniem oraz pamiętaj o śledzeniu i kwestiach celnych przy zamówieniach międzynarodowych.",
  "article.s7Title": "Wskazówki bezpieczeństwa przed zakupem",
  "article.s7Text": "Zachowaj ostrożność na każdym kroku. Zweryfikuj, że jesteś na właściwej stronie, dwukrotnie sprawdź informacje o sprzedawcy i produkcie oraz unikaj podejrzanych linków lub niechcianych wiadomości z prośbą o dane osobowe.",
  "article.s7Text2": "Korzystaj z bezpiecznych metod płatności, przechowuj zapisy zamówień i przeczytaj informacje o zwrotach lub reklamacjach przed zapłatą. Jeśli coś wydaje się podejrzane, zatrzymaj się i zweryfikuj niezależnie.",
  "article.faqTitle": "Najczęściej zadawane pytania",
  "article.faq": [
    {
      "q": "Czy USFans Spreadsheet jest darmowy?",
      "a": "Arkusz jest zasobem do przeglądania informacji o produktach. Szczegóły dostępu mogą się różnić, więc sprawdź aktualne informacje na oficjalnej stronie."
    },
    {
      "q": "Czy mogę ufać każdemu produktowi w arkuszu?",
      "a": "Nie. Arkusz porządkuje informacje, ale nadal powinieneś niezależnie weryfikować produkty, sprzedawców i płatności przed zakupem."
    },
    {
      "q": "Jak sprawdzić zdjęcia QC?",
      "a": "Gdy zdjęcia QC są dostępne, przejrzyj je pod kątem szwów, etykiet i widocznych śladów oraz porównaj z opisem produktu."
    },
    {
      "q": "Co zrobić przed złożeniem zamówienia?",
      "a": "Potwierdź aktualną cenę, dostępność, koszt wysyłki i szczegóły sprzedawcy oraz przeczytaj politykę zwrotów przed zapłatą."
    }
  ],
  "article.relatedTitle": "Czytaj dalej",
  "article.relatedBody": "Szukasz więcej? Wróć na stronę główną, aby przeglądać kategorie produktów, odkrywać nasze zasoby i znajdować kolejne niezależne poradniki.",
  "article.ctaTitle": "Gotowy na odkrycie USFans Spreadsheet?",
  "article.ctaBody": "Teraz, gdy rozumiesz, jak to działa, otwórz USFans Spreadsheet i zacznij badać produkty z pewnością.",
  "article.ctaButton": "Otwórz USFans Spreadsheet",
  "article.author": "Zespół redakcyjny USFansLink",
  "article.categoryLabel": "Poradnik",
  "article.notFoundTitle": "Nie znaleziono strony",
  "article.notFound": "Nie mogliśmy znaleźć tego artykułu.",
  "notFound.title": "Nie znaleziono strony",
  "notFound.body": "Strona, której szukasz, nie istnieje lub została przeniesiona."
};